<template>
  <section class="dp-layout">
    <section class="dp-right op-page">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Identity mapping</div>
        <h3 class="op-page__title">数据映射查询</h3>
        <p class="op-page__desc">核对合作方标识、本地实体与天波编号的对应关系，定位生命周期和同步状态异常。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新映射</el-button>
    </header>

    <div class="toolbar-filter-bar">
    <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
      <div class="toolbar-filter-fields">
      <el-form-item label="学校编号">
        <el-input v-model="filters.schoolDepartmentId" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filters.entityType" clearable class="toolbar-field-w-md">
          <el-option label="部门" value="dept" />
          <el-option label="学生" value="student" />
          <el-option label="教师" value="staff" />
          <el-option label="监护人" value="studentParent" />
          <el-option label="设备" value="device" />
          <el-option label="门禁规则" value="accessRule" />
          <el-option label="门禁子规则" value="accessSubRule" />
        </el-select>
      </el-form-item>
      <el-form-item label="外部标识">
        <el-input v-model="filters.externalId" clearable class="toolbar-field-w-md" />
      </el-form-item>
      <el-form-item label="本地编号">
        <el-input v-model="filters.localEntityId" clearable class="toolbar-field-w-md" />
      </el-form-item>
      <el-form-item label="同步状态">
        <el-select v-model="filters.syncStatus" clearable class="toolbar-field-w-sm">
          <el-option label="成功" value="succeeded" />
          <el-option label="失败被拒" value="rejected" />
          <el-option label="等待处理" value="pending" />
          <el-option label="同步中" value="syncing" />
          <el-option label="失败等再试" value="retryPending" />
          <el-option label="结果不清楚" value="unknownOutcome" />
          <el-option label="需要人工看着" value="manualReview" />
        </el-select>
      </el-form-item>
      <el-form-item label="生命周期">
        <el-select v-model="filters.lifeCycle" clearable class="toolbar-field-w-sm">
          <el-option label="有效" value="Active" />
          <el-option label="待删除" value="PendingDelete" />
          <el-option label="已删除" value="Deleted" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      </div>
    </el-form>
    </div>

    <div class="tbl-scroll-host">
    <el-table :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无映射"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">{{ entityTypeText(scope.row.EntityType) }}</template>
      </el-table-column>
      <el-table-column label="名称" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="op-name">{{ scope.row.DisplayName || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ExternalId" label="外部标识" min-width="140" show-overflow-tooltip />
      <el-table-column label="本地编号" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="op-mono">{{ scope.row.LocalEntityId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="天波编号" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="op-mono">{{ scope.row.TbEntityId || '—' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="同步状态" width="110">
        <template slot-scope="scope">
          <span :class="syncStatusClass(scope.row.SyncStatus)">{{ syncStatusText(scope.row.SyncStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="生命周期" width="90">
        <template slot-scope="scope">{{ lifeCycleText(scope.row.LifeCycle) }}</template>
      </el-table-column>
      <el-table-column label="学校" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.SchoolName || '—' }}</div>
          <div v-if="scope.row.SchoolId" class="op-sub">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="158" />
    </el-table>
    </div>

    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        :total="total" style="float: right" @current-change="load" />
    </el-col>
    </section>
  </section>
</template>

<script>
import { getPartnerMappingPage } from '@/api/modules/openPlatform';
import {
  entityTypeText,
  lifeCycleText,
  syncStatusText,
  syncStatusClass
} from '@/utils/openPlatformLabels';

export default {
  name: 'EntityMapping',
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      filters: {
        schoolDepartmentId: '',
        entityType: '',
        externalId: '',
        localEntityId: '',
        syncStatus: '',
        lifeCycle: ''
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    entityTypeText,
    lifeCycleText,
    syncStatusText,
    syncStatusClass,
    handleSearch() {
      this.page = 1;
      this.load();
    },
    load() {
      this.loading = true;
      const params = { page: this.page, pageSize: this.pageSize, ...this.filters };
      Object.keys(params).forEach(k => {
        if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
      });
      getPartnerMappingPage(params).then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.tableData = page.data || [];
          this.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => { this.loading = false; });
    }
  }
};
</script>

<style scoped>
.op-name { font-weight: 500; color: #303133; }
.op-mono { font-family: Consolas, Monaco, monospace; font-size: 12px; color: #606266; }
.op-sub { margin-top: 2px; font-size: 12px; color: #c0c4cc; }
.is-ok { color: #67c23a; }
.is-warn { color: #e6a23c; }
.is-bad { color: #f56c6c; }
</style>
